import { Component, Input, OnInit, ViewChild, Output, EventEmitter, ViewEncapsulation } from '@angular/core';
import { DxListComponent } from 'devextreme-angular';
import { SearchMode } from '../../../base/src/abcListBox/abcListBox';

@Component({
  selector: '',
  template: `<dx-list
    #dxListBox
    class="devExListBoxStyle"
    [dataSource]="dataSource"
    [items]="source"
    [height]="height"
    [width]="width"
    [allowItemDeleting]="allowItemDeleting"
    [scrollingEnabled]="scrollingEnabled"
    [itemDeleteMode]="itemDeleteMode"
    [hoverStateEnabled]="hoverStateEnabled"
    [selectedItemKeys]="checkedList"
    [showSelectionControls]="showSelectionControls"
    [selectionMode]="selectionMode"
    [searchEnabled]="searchEnabled"
    [searchExpr]="searchExpr"
    [searchMode]="searchMode"
    [searchValue]="searchValue"
    [showScrollbar]="showScrollbar"
    [collapsibleGroups]="collapsibleGroups"
    [grouped]="grouped"
    [activeStateEnabled]="activeStateEnabled"
    [class]="class"
    [focusStateEnabled]="focusStateEnabled"
    [disabled]="disabled"
    [rtlEnabled]="rtlEnabled"
    [visible]="visible"
    (onItemClick)="itemClick($event)"
    (onSelectionChanged)="selectionChanged($event)"
    (onItemDeleting)="itemDeleting($event)"
    (onContentReady)="contentReady($event)"
  >
    <div *ngIf="showTemplateImage">
      <div *dxTemplate="let item of 'item'">
        <img src="{{ item.ImageSrc }}" style="width:20px;float:left;padding-right:5px" />
        <div class="item-text">{{ item.text }}</div>
      </div>
    </div>

    <div *ngIf="showDxTemplate">
      <div *dxTemplate="let item of 'item'">
        <div class="city">{{ item[dynamicKey] || '' }}</div>
      </div>
    </div>

    <div *ngIf="groupImages">
      <div *dxTemplate="let groupObj of 'group'">
        <div class="list-header-images">
          <img src="{{ groupImages[groupObj.key] || groupImages['Default'] }}" />{{ groupObj.key }}
        </div>
      </div>
    </div>

    <div *ngIf="showCommentsTemplate">
      <div *dxTemplate="let item of 'item'">
        <span style="font-weight:bold;">{{ item.data.RefreshedBy }}</span>
        <span> | </span>
        <span style="font-size: 10px;color: gray;">{{ item.data.Identifier }}</span>
        <span class="comment-time">{{ item.data.RefreshedOn }}</span>
        <div class="comment-body" [class.overflow]="isExpand">{{ item.data.Text }}</div>
      </div>
    </div>
  </dx-list>`,
  styleUrls: ['./devExListBox.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
})
export class DevExListBoxComponent implements OnInit {
  @ViewChild('dxListBox') dxListBox: DxListComponent;
  @Input() dataSource: any;
  @Input() width: string | number;
  @Input() height: string | number;
  @Input() checkboxes: boolean;
  @Input() selectionMode: string;
  @Input() searchValue: string;
  @Input() showSelectionControls: boolean;
  @Input() searchEnabled: boolean;
  @Input() searchExpr: boolean;
  @Input() searchMode: SearchMode;
  @Input() allowItemDeleting: boolean;
  @Input() itemDeleteMode: string = 'static';
  @Input() dynamicKey: string;
  @Input() grouped: boolean;
  @Input() showDxTemplate: boolean;
  @Input() showCommentsTemplate: boolean;
  @Input() showTemplateImage: boolean;
  @Input() collapsibleGroups: boolean;
  @Input() hoverStateEnabled: boolean;
  @Input() focusStateEnabled: boolean;
  @Input() visible: boolean;
  @Input() class: string;
  @Input() string: string;
  @Input() rtlEnabled: boolean;
  @Input() selectedItems: any;
  @Input() disabled: boolean;
  @Input() showScrollbar: string;
  @Input() scrollingEnabled: boolean = true;
  @Input() activeStateEnabled: boolean;
  @Input() groupImages: any;
  @Input()
  get source() {
    return this._source;
  }
  set source(source: any) {
    this._source = this.contentChange(source);
    if (source) {
      this.refresh();
    }
  }
  @Output() onItemClick = new EventEmitter();
  @Output() onSelectionChanged = new EventEmitter();
  @Output() onItemDeleting = new EventEmitter();
  @Output() onContentReady = new EventEmitter();
  public checkedList = [];
  private _source;
  public isExpand: boolean = true;
  data: any[];

  constructor() {}

  ngOnInit() {}

  contentChange(source) {
    if (source) {
      source = source.map((item) => ({
        id: item.id,
        text: item.caption,
        badge: item.badge,
        isSelected: item.checked,
        group: item.name,
        data: item.data,
      }));
      source.forEach((element) => {
        if (element.isSelected === undefined) {
          element.isSelected = false;
        }
      });
      this.checkExistingColumns(source);
    }
    this.refresh();
    return source;
  }

  checkExistingColumns(data: any[]) {
    if (this.checkboxes === true) {
      for (let index = 0; index <= data.length; index++) {
        if (data[index] !== undefined && data[index].hasOwnProperty('isSelected') && data[index].isSelected === true)
          this.checkedList.push(data[index]);
      }
    }
  }

  checkChange(event: Event) {
    return this.dxListBox.selectedItems;
  }

  assignOpathToData(data: Array<any>) {
    let oPathData = [];
    this.source.forEach((element) => {
      data.forEach((subElement) => {
        if (element.text === subElement.text) {
          subElement.group = element.group;
          oPathData.push(subElement);
        }
      });
    });
  }

  itemClick(event: Event) {
    this.isExpand = !this.isExpand;
    this.onItemClick.emit(event);
  }

  selectionChanged(event: Event) {
    this.isExpand = !this.isExpand;
    this.onSelectionChanged.emit(event);
  }

  itemDeleting(event: Event) {
    this.onItemDeleting.emit(event);
  }

  refresh() {
    this.dxListBox?.instance.repaint();
  }

  unselectAll() {
    this.dxListBox?.instance?.unselectAll();
  }

  contentReady(event: Event) {
    this.onContentReady.emit(event);
  }
}
